var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshopFacilitatorInActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6393 0.894531H2.57065C1.42706 0.894531 0.5 1.82159 0.5 2.96518V11.0339C0.5 12.1775 1.42706 13.1045 2.57065 13.1045H10.6393C11.7829 13.1045 12.71 12.1775 12.71 11.0339V2.96518C12.71 1.82159 11.7829 0.894531 10.6393 0.894531Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 5.44555L17.4968 2.14844V11.8486L12.707 8.5538",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74667 8.4367C7.5409 8.4367 8.18475 7.79285 8.18475 6.99863C8.18475 6.2044 7.5409 5.56055 6.74667 5.56055C5.95244 5.56055 5.30859 6.2044 5.30859 6.99863C5.30859 7.79285 5.95244 8.4367 6.74667 8.4367Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopFacilitatorInActive);
export default __webpack_public_path__ + "static/media/WorkshopFacilitatorInActive.af0964b0867d7aac282191507bf71871.svg";
export { ForwardRef as ReactComponent };